export class AssignedAssetsModel {
    constructor() {
        this.assetType = "";
        this.assetCode = "";
        this.assetName = "";
        this.assignmentStartDateAsString = "";
    }
}
export default class AssignedAssets extends AssignedAssetsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
